const wedding_party = {
    david: { name: "David Wing", title: "The Groom", fb: "https://www.facebook.com/david.wing.142/", image: "/photos/pfp/david.jpg" },
    tala: { name: "Tala Reese", title: "The Bride", fb: "", image: "/photos/pfp/tala.jpg" },
    dan: { name: "Daniel Irby", title: "The Best Man", fb: "", image: "/photos/pfp/dan.jpg" },
    abby: { name: "Abby Kaye", title: "The Maid of Honor", fb: "", image: "/photos/pfp/abby.jpg" },

    callan: { name: "Callan Reese", title: "Groomsman", fb: "", image: "/photos/pfp/callan.jpg" },
    kyle_niksa: { name: "Kyle Niksa", title: "Groomsman", fb: "", image: "/photos/pfp/kyle_n.jpg" },
    kyle_moran: { name: "Kyle Moran", title: "Groomsman", fb: "", image: "/photos/pfp/kyle_moran.jpg" },
    alex_wing: { name: "Alex Wing", title: "Groomsman", fb: "https://www.instagram.com/wingding579", image: "/photos/pfp/alex.png" },
    bobby: { name: "Bobby Daniel", title: "Groomsman", fb: "", image: "/photos/pfp/bobby.jpg" },
    michael_ashbrook: {
        name: "Michael Ashbrook", fb: "", title: "Groomsman", image: "/photos/pfp/michael.jpg",

    },
    niksa: { name: "Kyle Niksa", title: "Groomsman", fb: "", image: "/photos/pfp/niksa.jpg" },


    tori_wing: { name: "Tori Wing", title: "Bridesmaid", fb: "", image: "/photos/pfp/tori.jpg" },
    lauren_walker: { name: "Lauren Walker", title: "Bridesmaid", fb: "https://www.instagram.com/walker.pdf", image: "/photos/pfp/lauren.jpg" },
    ceecee_darmes: { name: "Ceecee Darmes", title: "Bridesmaid", fb: "https://www.facebook.com/ceecee.darmes", image: "/photos/pfp/cc.jpg" },
    morgan_vasas: { name: "Morgan Vasas", title: "Bridesmaid", fb: "", image: "/photos/pfp/morgan.jpg" },
};

export default wedding_party;
